import { configureStore } from "@reduxjs/toolkit"
import mainReducer from "./reducers/main/mainReducer";
import authReducer from "./reducers/auth/authReducer";
import productReducer from "./reducers/product/productReducer";
import categoryReducer from "./reducers/category/categoryReducer";
import currencyReducer from "./reducers/currency/currencyReducer";



const store = configureStore({
    reducer: {
        main: mainReducer,
        auth: authReducer,
        product: productReducer,
        category: categoryReducer,
        currency: currencyReducer,
    }
})

export default store;